// extracted by mini-css-extract-plugin
export default {"checkboxTree":"src-components-Filter-components-collapsable-CheckboxTree__checkboxTree--aIMXm"};